import { H2, IconList, SpacerWrapper } from '@ahmdigital/ui';
import { map } from 'lodash/fp';
import React from 'react';

import { Services as ServicesProps } from '../../../../types';

type Props = ServicesProps & {
  heading: string;
  iconProps: {
    fill: string;
    icon: string;
  };
};

const Services = ({ callout, iconProps, heading, items }: Props) => (
  <div>
    <H2 looksLike="h4" variant="marginBottomSpacer11">
      {heading}
    </H2>
    <IconList
      items={[
        ...map(
          ({ name: text }) => ({
            ...iconProps,
            text,
          }),
          items,
        ),
      ]}
      variant="simple"
    />
    {callout && <SpacerWrapper variant="marginTopSpacer11">{callout}</SpacerWrapper>}
  </div>
);

export default Services;
